/** @jsx jsx */
import React from 'react';
import { jsx, Box } from 'theme-ui';

const ComparisonChart = ({ 
  items = [],
  totalValue = '',
  totalPrice = '',
  savingsText = '',
  savingsAmount = '',
  showDivider = true,
  textColor = '#2c3e50',
  freeColor = '#275681',
  savingsColor = '#275681'
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '600px',
        margin: '0 auto',
        fontFamily: 'inherit',
      }}
    >
      {/* Main items */}
      <Box
        sx={{
          display: 'flex',
          marginBottom: showDivider ? '16px' : '0',
        }}
      >
        {/* Product names column */}
        <Box
          sx={{
            flex: '1',
            marginRight: '10px',
            width: '300px',
            '@media only screen and (max-width: 600px)': {
              width: '75%',
            },
          }}
        >
          {items.map((item, index) => (
            <Box
              key={index}
              as="p"
              sx={{
                fontSize: '19px !important',
                lineHeight: 2,
                margin: 0,
                color: textColor,
                '@media only screen and (max-width: 600px)': {
                  fontSize: '15px',
                  lineHeight: 2,
                },
              }}
            >
              {item.name}
            </Box>
          ))}
        </Box>

        {/* Prices column */}
        <Box
          sx={{
            flex: '0 0 auto',
            minWidth: '120px',
          }}
        >
          {items.map((item, index) => (
            <Box
              key={index}
              as="p"
              sx={{
                fontSize: '19px !important',
                lineHeight: 2,
                textAlign: 'right',
                margin: 0,
                color: item.isFree ? freeColor : textColor,
                fontStyle: item.isFree ? 'italic' : 'normal',
                fontWeight: item.isFree ? 'bold' : 'normal',
                '@media only screen and (max-width: 600px)': {
                  fontSize: '15px',
                  lineHeight: 2,
                },
              }}
            >
              {item.isFree ? (
                <Box as="strong" sx={{ color: freeColor }}>
                  {item.price}
                </Box>
              ) : (
                item.price
              )}
            </Box>
          ))}
        </Box>
      </Box>

      {/* Divider */}
      {showDivider && (
        <Box
          as="hr"
          sx={{
            border: 'none',
            borderTop: '1px solid #6c757d',
            margin: '16px 0',
          }}
        />
      )}

      {/* Total section */}
      {(totalValue || totalPrice || savingsText || savingsAmount) && (
        <Box
          sx={{
            display: 'flex',
          }}
        >
          {/* Total labels column */}
          <Box
            sx={{
              flex: '1',
              marginRight: '10px',
              width: '300px',
              '@media only screen and (max-width: 600px)': {
                width: '75%',
              },
            }}
          >
            {totalValue && (
              <Box
                as="p"
                sx={{
                  fontSize: '19px !important',
                  lineHeight: 2,
                  margin: 0,
                  color: textColor,
                  '@media only screen and (max-width: 600px)': {
                    fontSize: '15px',
                    lineHeight: 2,
                  },
                }}
              >
                {totalValue}
              </Box>
            )}
            {savingsText && (
              <Box
                as="p"
                sx={{
                  fontSize: '19px !important',
                  lineHeight: 2,
                  margin: 0,
                  color: textColor,
                  '@media only screen and (max-width: 600px)': {
                    fontSize: '15px',
                    lineHeight: 2,
                  },
                }}
              >
                <Box as="em">
                  <Box as="strong">{savingsText}</Box>
                </Box>
              </Box>
            )}
          </Box>

          {/* Total values column */}
          <Box
            sx={{
              flex: '0 0 auto',
              minWidth: '120px',
            }}
          >
            {totalPrice && (
              <Box
                as="p"
                sx={{
                  fontSize: '19px !important',
                  lineHeight: 2,
                  textAlign: 'right',
                  margin: 0,
                  color: textColor,
                  '@media only screen and (max-width: 600px)': {
                    fontSize: '15px',
                    lineHeight: 2,
                  },
                }}
              >
                {totalPrice}
              </Box>
            )}
            {savingsAmount && (
              <Box
                as="p"
                sx={{
                  fontSize: '19px !important',
                  lineHeight: 2,
                  textAlign: 'right',
                  margin: 0,
                  color: textColor,
                  '@media only screen and (max-width: 600px)': {
                    fontSize: '15px',
                    lineHeight: 2,
                  },
                }}
              >
                <Box as="em">
                  <Box as="strong">{savingsAmount}</Box>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ComparisonChart;
